export function loadScript(path, { defer = false } = {}) {
  return new Promise(function(resolve, reject) {
    let script = document.createElement("script")
    script.src = path
    script.async = true
    script.defer = defer

    script.onload = function(event) {
      resolve([script, event])
    }

    script.onerror = function(event) {
      reject([script, event])
    }

    document.head.appendChild(script)
  })
}
